import { useCallback, useEffect, useState } from 'react'

import { PostMessageType, WindowEventMessage } from './types'

export function usePostMessage<TPayload = undefined>(
  type: PostMessageType,
  msgOnMount?: WindowEventMessage<TPayload>,
  targetOrigin = window.origin,
) {
  const [isLoading, setIsLoading] = useState(!!msgOnMount)
  const [isError, setIsError] = useState(false)

  const postMessage = useCallback(
    (msg: WindowEventMessage<TPayload>) => {
      setIsLoading(true)

      if (type === PostMessageType.iframe) {
        if (window.location !== window.parent.location) {
          window.parent.postMessage(msg, targetOrigin)
        } else {
          setIsError(true)
        }
      }

      if (type === PostMessageType.popup) {
        if (window.opener) {
          window.opener.postMessage(msg, targetOrigin)
          window.opener.focus()
          window.close()
        } else {
          setIsError(true)
        }
      }

      setIsLoading(false)
    },
    [type, targetOrigin],
  )

  useEffect(() => {
    if (msgOnMount) {
      postMessage(msgOnMount)
    }
  }, [msgOnMount, postMessage])

  return { isError, isLoading, postMessage }
}
